import { cn } from "@/lib/utils";

export function PayOptionCard({
  selected, onSelect, title, description, badge,
}: { selected: boolean; onSelect: () => void; title: string; description: string; badge?: string }) {
  return (
    <button
      type="button"
      onClick={onSelect}
      className={cn(
        "cursor-pointer flex w-full items-start gap-3 rounded-xl border p-4 text-left transition-colors",
        selected ? "border-foreground bg-muted/40" : "border-border hover:border-foreground/40"
      )}
    >
      <span
        className={cn(
          "mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2",
          selected ? "border-foreground" : "border-muted-foreground/40"
        )}
      >
        {selected && <span className="h-2.5 w-2.5 rounded-full bg-foreground" />}
      </span>
      <div className="flex-1">
        <div className="flex items-center gap-2">
          <p className="text-sm font-semibold text-foreground">{title}</p>
          {badge && (
            <span className="rounded-full bg-pink-100 px-2 py-0.5 text-[10px] font-bold text-pink-700">{badge}</span>
          )}
        </div>
        <p className="mt-0.5 text-xs text-muted-foreground">{description}</p>
      </div>
    </button>
  );
}

export function Row({ label, value, green, help }: { label: string; value: string; green?: boolean; help?: string }) {
  return (
    <div>
      <div className="flex items-baseline justify-between">
        <span className={cn("text-sm", green ? "text-green-600" : "text-muted-foreground")}>{label}</span>
        <span className={cn("text-sm tabular-nums", green ? "text-green-600" : "text-foreground")}>{value}</span>
      </div>
      {help && <p className="mt-0.5 text-[11px] text-muted-foreground">{help}</p>}
    </div>
  );
}
